/* eslint-disable import/no-extraneous-dependencies */
import React, { PropTypes } from 'react'
import moment from 'moment'
import { dateFormatter } from 'lib/helpers'
import { map } from 'lodash/collection'
import Tooltip from 'rc-tooltip'
import { Table, Thead, Th, Tr, Td } from 'components/reactable'
import styles from './FinancesTransactions.scss'
import translate from '../translation'

const FinancesTooltip = ({id, children}) => (
	<Tooltip
		placement="top"
        trigger={['hover']}
		overlay={<div style={{maxWidth: '10em'}}>{translate(id)}</div>}
		transitionName="rc-tooltip-zoom"
		mouseEnterDelay={0.1}
	>
		{children}
	</Tooltip>
)
FinancesTooltip.propTypes = {
    id: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
}

const Transactions = ({items, summary}) => {
	const formatedDates = items ? items.map(item => ({...item, date: moment(item.date).format("DD-MM-YYYY")})) : []
	return (
		<div className={`${styles.transContainer}`}>
			<div className={`${styles.summaryContainer}`}>
				<div className={`${styles.summary}`}>
					{map(summary, (item, key) =>
						<div key={key} className={`${styles.field}`}>
							<div className={`${styles.label}`}>
								<p>{translate(key)}</p>
							</div>
							<div className={`${styles.input}`}>
								<input disabled="true" type="text" value={item}/>
							</div>
						</div>
					)}
				</div>
			</div>
			<Table
				itemsPerPage={15}
				filterable={[
					'date',
					'reference',
					'invoiceNumber',
					'contractNumber',
					'client',
					'insuranceCompany',
					'dueDate',
					'transactionType',
					'description',
					'debitCode',
					'debitAmount',
					'creditCode',
					'creditAmount',
				]}
				sortable={[
					{column: 'date', sortFunction: 'Date'},
					'reference',
					'invoiceNumber',
					'contractNumber',
					'client',
					'insuranceCompany',
					'dueDate',
					'transactionType',
					'description',
					'debitCode',
					'debitAmount',
					'creditCode',
					'creditAmount',
				]}
				defaultSort={{
					column: 'date',
					direction: 'desc',
				}}
			>
				<Thead>
					<Th column="date">
						<FinancesTooltip id="dateTT">
							<span>{translate('date')}</span>
						</FinancesTooltip>
					</Th>
					<Th column="reference">
						<FinancesTooltip id="referenceTT">
							<span>{translate('reference')}</span>
						</FinancesTooltip>
					</Th>
					<Th column="invoiceNumber">
						<FinancesTooltip id="invoiceNumberTT">
							<span>{translate('invoiceNumber')}</span>
						</FinancesTooltip>
					</Th>
					<Th column="contractNumber">
						<FinancesTooltip id="contractNumberTT">
							<span>{translate('contractNumber')}</span>
						</FinancesTooltip>
					</Th>
					<Th column="client">
						<FinancesTooltip id="clientTT">
							<span>{translate('client')}</span>
						</FinancesTooltip>
					</Th>
					<Th column="insuranceCompany">
						<FinancesTooltip id="insuranceCompanyTT">
							<span>{translate('insuranceCompany')}</span>
						</FinancesTooltip>
					</Th>
					<Th column="dueDate">
						<FinancesTooltip id="dueDateTT">
							<span>{translate('dueDate')}</span>
						</FinancesTooltip>
					</Th>
					<Th column="transactionType">
						<FinancesTooltip id="transactionTypeTT">
							<span>{translate('transactionType')}</span>
						</FinancesTooltip>
					</Th>
					<Th column="description">
						<FinancesTooltip id="descriptionTT">
							<span>{translate('description')}</span>
						</FinancesTooltip>
					</Th>
					<Th column="debitCode">
						<FinancesTooltip id="commTT">
							<span>{translate('debitCode')}</span>
						</FinancesTooltip>
					</Th>
					<Th column="debitAmount">
						<span>{translate('debitAmount')}</span>
					</Th>
					<Th column="creditCode">
						<FinancesTooltip id="commTT">
							<span>{translate('creditCode')}</span>
						</FinancesTooltip>
					</Th>
					<Th column="creditAmount">
						<span>{translate('creditAmount')}</span>
					</Th>
				</Thead>
				{
					formatedDates.map((item, key) =>
						<Tr className="centered" key={key} data={item}>
							<Td className="bhkDatum" column="date" data={dateFormatter(item.date)}/>
							<Td column="reference">{item.reference}</Td>
							<Td column="invoiceNumber">{item.invoiceNumber}</Td>
							<Td column="contractNumber">{item.contractNumber}</Td>
							<Td column="client">{item.client}</Td>
							<Td column="insuranceCompany">{item.insuranceCompany}</Td>
							<Td column="dueDate">{`${item.dueDate.slice(2, 4)}/${item.dueDate.slice(0, 2)}`}</Td>
							<Td column="transactionType">{item.transactionType}</Td>
							<Td column="description">{item.description}</Td>
							<Td column="debitCode">{item.debitCode}</Td>
							<Td column="debitAmount" value={Number(item.debitAmount)}>{item.debitAmount}</Td>
							<Td column="creditCode">{item.creditCode}</Td>
							<Td column="creditAmount" value={Number(item.creditAmount)}>{item.creditAmount}</Td>
						</Tr>
					)
				}
			</Table>
		</div>
	)
}
Transactions.propTypes = {
    items: PropTypes.array,
    summary: PropTypes.object.isRequired,
}

export default Transactions



// WEBPACK FOOTER //
// ./components/office/finances/FinancesTransactions.jsx